import { logout, setAuthToken } from '../api/auth';

export function handleLogout() {
  setAuthToken(null);
  localStorage.removeItem('authToken');
  sessionStorage.removeItem('authToken');
  logout();
}
